import {Component} from "react";
import simplyContext from "../../../../settings/state/simply";
import withRouter from "../../../main/withRouter"
import {funcNavigate} from "../../../../settings/utils/functions";
import {Helmet, HelmetProvider} from "react-helmet-async";
import {NavLink} from "react-router-dom";
import {header} from "../../components/header";
import {footer} from "../../components/footer";
import {urlDynamic} from "../../../../settings/utils/urlDynamic";
import {notFound} from "../../components/notFound";
import PaginationFilter from "../../components/PaginationFilter";

class NewsAllMarjaiat extends Component {
    static contextType = simplyContext

    componentDidMount() {
        const searchParams = new URLSearchParams(this.props.location.search);
        const pageValue = searchParams.get('page');
        this.context.fNewsMarjaiat({
            'pageNumber': pageValue,
        })
    }


    componentDidUpdate(prevProps, prevState, snapshot) {
        funcNavigate(this.props.navigate, this.context)
        if (this.props.location.key !== prevProps.location.key) {
            const searchParams = new URLSearchParams(this.props.location.search);
            const pageValue = searchParams.get('page');
            this.context.fNewsMarjaiat({
                'pageNumber': pageValue,
            })
        }
    }


    render() {
        return (
            <HelmetProvider>
                <Helmet>
                    <title>آرشیو اخبار مرجعیت علمی</title>
                    <link rel="canonical" href={"https://nasrme.ac.ir/آرشیو-اخبار-مرجعیت-علمی"} />
                </Helmet>

                {this.context.state.sNews !== null ? (
                    <div className='container-fluid cFlex1'>

                        {header(this.context)}


                        <div className='row py-2 cBg7 justify-content-center cPx1 cBrudcRum'>
                            <div className='cContainer col-12'>
                                <div className='row justify-content-center'>
                                    <div className='col-12 lh-lg'>
                                        <NavLink to={urlDynamic.path.homeFa}
                                                 className='text-white cFontSize13 cHover4 cTransition'>صفحه
                                            اصلی</NavLink>
                                        <span className='mx-1 cFontSize13 text-white'>/</span>
                                        <h1 className='cColor2 d-inline-block cFontSize13'>آرشیو اخبار مرجعیت علمی</h1>
                                    </div>
                                </div>
                            </div>
                        </div>

                         {this.context.state.sNews.notFound === true ? (
                            notFound()
                        ) : (
                            <div className='row pt-5 position-relative cBg3 justify-content-center cPx1 cFlex2'>
                            <div className='cContainer col-12'>
                                <div className='row cBg4 justify-content-center'>
                                    <div className='col-12'>
                                        <div className='row'>
                                            {this.context.state.sNews.news.map((p, index) => (
                                                <div key={index} className='col-12 col-sm-6 col-lg-3 mb-5'>
                                                     <div key={index}>
                                                            <NavLink to={'/' + p.url}
                                                                     className="cHover7 card position-relative overflow-hidden rounded-0 h-100 rounded rounded-4">
                                                                <img src={p.urlImage} width="960" height='720'
                                                                     className="img-fluid"
                                                                     alt="تصویر"/>
                                                            </NavLink>
                                                            <NavLink to={'/' + p.url}
                                                                     className='text-dark d-block text-center mt-2 lh-lg cFontSize12 fw-bold cHover2 cTransition'>
                                                                {p.title}
                                                            </NavLink>
                                                        </div>
                                                </div>
                                            ))}
                                            <div className='col-12 mb-5'>
                                                <PaginationFilter func={this.context.fDropDown}
                                                                              state={this.context.state.sNews}/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        )}

                        {footer()}


                    </div>
                ) : null}

            </HelmetProvider>
        )
    }
}

export default withRouter(NewsAllMarjaiat)